import React from "react";

const CPU = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M24.492 2H11.508A2.507 2.507 0 0 0 9 4.5v25.008c0 1.379 1.125 2.5 2.508 2.5h.868v1.054c0 .518.421.938.94.938.52 0 .941-.42.941-.938v-1.054h7.486v1.054c0 .518.42.938.94.938s.94-.42.94-.938v-1.054h.869a2.507 2.507 0 0 0 2.508-2.5V4.5C27 3.122 25.875 2 24.492 2ZM14.378 13.043c-.52 0-.94-.42-.94-.938 0-.517.42-.937.94-.937h7.181a.939.939 0 1 1 0 1.875h-7.18Zm4.559 14.044a.94.94 0 0 1-.274.66.946.946 0 0 1-.663.274.946.946 0 0 1-.662-.273.94.94 0 0 1-.275-.66c0-.246.1-.487.275-.661a.945.945 0 0 1 .662-.273c.247 0 .488.1.663.273a.94.94 0 0 1 .274.66Zm-5.5-18.778c0-.518.422-.938.941-.938h7.181a.939.939 0 1 1 0 1.875h-7.18c-.52 0-.941-.42-.941-.937Z"
            fill={fill}
        />
    </svg>
);

export default CPU;